import { User } from 'lib-shared-types-api';

import { usePaginatedEndpoint } from 'hooks/usePaginatedEndpoint';
import {
  InitialParams,
  StandardParams,
  UsePaginatedEndpointResult,
} from 'hooks/usePaginatedEndpoint/types';

import { AgentsResponseData, getAgents } from './api';

type SortKey = 'display_name' | 'email';
interface Params extends StandardParams<SortKey> {
  filter_out_by_team?: string;
  filter_out_by_queue?: string;
}

/**
 * @deprecated This hook is only used by `AgentsSelect` component, which is also
 *   deprecated and will be replaced with `HookFormAgentSelect`.
 */
export const useAgents = (
  initialParams: InitialParams<SortKey, Params>,
): UsePaginatedEndpointResult<User, SortKey, Params> =>
  usePaginatedEndpoint<User, AgentsResponseData, SortKey, Params>({
    endpoint: getAgents,
    itemsSelector: (data) => data.agents,
    totalSelector: (data) => data.number_of_agents,
    initialParams: { sortKey: 'display_name', ...initialParams },
  });
